const incidentTypeLabels = {
  AAF: 'At-Fault',
  NAF: 'Not At-Fault',
  CMP: 'Comprehensive',
  CMU: 'Comprehensive (Minor)',
  CCW: 'Comprehensive/Weather',
  MIN: 'Minor',
  MAJ: 'Major',
  D: 'Severity D',
  E: 'Severity E',
  F: 'Severity F',
  G: 'Severity G'
};

export const getIncidentTypeLabel = (type) => incidentTypeLabels[type] || type;
